import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from "@angular/router";

import { Constants } from "../../shared/constants/constants";

const DEFAULT_LANDING_URL = "/dashboard/target";

/**
 * Guard to ensure a valid session exists for protected routes.
 * If there is no session, user is redirected to the login page,
 * unless the route is in the list of allowed pages without a session.
 */
export function RedirectedUrlGuard(): CanActivateFn | CanActivateChildFn {
  return (_route, state): boolean | UrlTree => {
    const router = inject(Router);

    const allowedPagesWithoutSession = [
      "login",
      "android",
      "verification",
      "new-password",
      "forget-password",
      "link-account",
    ];

    const sessionId = localStorage.getItem(Constants.localStorageKeys.sessionId);

    if (!sessionId) {
      const url = state.url;
      const [path] = url.split("?");
      const pathParts = path.split("/").filter(Boolean);
      const firstPath = pathParts[0] ?? "";
      const redirectedUrl = url;

      const isPathAllowed = allowedPagesWithoutSession.includes(firstPath);

      //Opening "/" reaches the guard already redirected to the default landing page, so don't keep it as a
      //redirectUrl: it would skip the post-login routing by permission (homepage vs console)
      if (!isPathAllowed && redirectedUrl === DEFAULT_LANDING_URL) {
        return router.createUrlTree(["/login"]);
      }

      if (!isPathAllowed && redirectedUrl !== "/") {
        return router.createUrlTree(["/login"], {
          queryParams: { redirectUrl: redirectedUrl },
        });
      }
    }

    return true;
  };
}
